var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Section',{staticClass:"kpb-images-text-section",class:[
    `kpb-images-text-section-layout--${(_vm.layoutComp || '').includes('vertical') ? 'vertical' : 'horizontal'}`,
    `kpb-images-text-section-layout--${_vm.layoutComp || 'default'}`,
    `kpb-images-text-section-theme--${_vm.theme || 'none'}`,
    { 'kpb-images-text-section-theme': _vm.theme },
    { 'kpb-images-text-section--single': _vm.isSingle },
    { 'kpb-images-text-section--disable-resposive-padding': !_vm.showResponsivePadding },
  ],style:([
    {
      '--kpb-images-text-section-gap': _vm.gap,
      '--kpb-images-text-section-padding': _vm.padding,
      '--kpb-images-text-section-default-columns': _vm.isSingle ? '1fr' : 'repeat(2, 1fr)',
    },
  ]),attrs:{"width":_vm.width || 'medium',"theme":_vm.theme}},[((_vm.value.images || []).length)?[(_vm.imageLayout === 'slider')?_c('Slider',{staticClass:"kpb-images-text-section__slider",attrs:{"data":_vm.value.images}}):_c('Gallery',{staticClass:"kpb-images-text-section__images",class:[
        `kpb-images-text-section__images--layout-${_vm.imageLayout}`,
        {
          'kpb-images-text-section__images--span-last': _vm.spanLast,
        },
        {
          'kpb-images-text-section__images--frame': (_vm.value['image-settings'] || '').includes('frame'),
          'kpb-images-text-section__images--round-edges': (_vm.value['image-settings'] || '').includes('round-edges'),
        },
      ],attrs:{"caption-visibility":_vm.captionVisibility,"caption-placement":_vm.captionPlacement,"caption-position":_vm.captionPosition,"data":{ images: _vm.value.images }}})]:_vm._e(),(_vm.value.content)?_c('div',{staticClass:"kpb-images-text-section__content",class:[
      `kpb-images-text-section__content-size--${_vm.value['text-width'] || 'medium'}`,
      {
        'kpb-images-text-section__content--text-over': (_vm.value['image-settings'] || '').includes('text-over'),
      },
    ]},[_c('TextComponent',{attrs:{"data":{ content: _vm.content },"text-align":(_vm.value['text-settings'] || '').includes('center') ? 'center' : 'start'}})],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }